// Material
import Paper from "@mui/material/Paper";
import { Skeleton, Box } from "@mui/material";
// Components
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";

type CommissionCycleAdjustmentLoaderProps = {
	loading: boolean;
};

export default function CommissionCycleAdjustmentLoader(props: Readonly<CommissionCycleAdjustmentLoaderProps>) {
	return (
		<Paper elevation={0} sx={{ width: "100%", borderRadius: "10px", display: props.loading ? "block" : "none" }}>
			<Skeleton
				sx={{
					borderRadius: "6px",
				}}
				variant="rectangular"
				width={160}
				height={30}
			/>
			<Box
				sx={{
					display: "flex",
					justifyContent: "flex-end",
					alignItems: "center",
					columnGap: 2,
					margin: "15px 0",
				}}
			></Box>
			<Skeleton
				sx={{
					borderRadius: "6px",
				}}
				variant="rectangular"
				width="100%"
				height={23}
			/>
			<TableLoader
				sx={{
					marginTop: "-10px !important",
				}}
				content
				rows={3}
			/>
		</Paper>
	);
}
